<template>
        <div>
                <el-dialog
                        :visible.sync="dialogVisible"
                        width="70%"
                        :title="title"
                        append-to-body
                        :modal-append-to-body='false'
                        :show-close='false'
                        :close-on-press-escape='false'
                        :close-on-click-modal="false"
                       
                        >

                        <avue-form
                                :option="option"
                                v-model="form"
                                v-if="dialogVisible"
                                ref="form"
                                
                                @submit="(form,done)=>submit(1,form,done)"
                                @error="formError"
                        >
                        <template slot="deptId">
                                <el-select v-model="form.deptId"
                                        :disabled="disabled"
                                        @change="deptIdChange"
                                >
                                        <el-option
                                                v-for="item in deptList"
                                                :key="item"
                                                :value="item.id"
                                                :label="item.fullName"
                                        >

                                        </el-option>
                                </el-select>
                        </template>
                        
                        
                        
                        
                                <template slot="menuForm">
                                       
                                        <el-button
                                                v-if="editable"
                                                :loading="loading"
                                                @click="submit(2)"
                                          type="primary">
                                                提交
                                        </el-button>
                                        <el-button 
                                         :loading="loading"
                                        @click="submit(3)">
                                                取消
                                        </el-button>
                                </template>
                                <template slot="dataList">
                                        <div>
                                          <ConsumableSelector
                                                :showSum='false'
                                                :showOnlySum='true'
                                                ref="cs"
                                                :columns="csColumns"
                                                :numberMode="numberMode"
                                                :numberKey="'distributeNum'"
                                                :priceKey="'distributeNum'"
                                                :data.sync="csData"
                                                :projectId="this.form.projectId"
                                                @loadData="loadData"
                                                :priceMode="priceMode"
                                                @loadPrice="loadPrice"
                                                :editable="editable"
                                                @afterAdd="csDataAfterAdd"
                                                :scene="'out'"
                                                />
                                        </div>
                                       
                                </template>
                        </avue-form>
                        
                </el-dialog>
                
        </div>
</template>
<script>
import formOption from "./recipients-from-option";
import ConsumableSelector from '@/components/consumable-selector/index';

    
import {treeDeptsByIds,
distributeSave,
distributeSubmit,
getUserNowList,
getConsumableListByDistributeId,
consumableList
} from "@/api/crmedical/warehouse/outbound/grant.js";
import {
  getProjectList,
  getDict,
  getBusinessNo
} from "@/api/crmedical/warehouse/index.js";
import {
  treeByProjectDeptId,

} from "@/api/crmedical/group/group";
import {mapGetters} from "vuex";
export default {
        components:{
                ConsumableSelector
        },
        props:{

        },
        data(){
                
                return{
                        title:'',
                        useUserList:[],//使用人列表
                        auditBtn:false,
                        printBtn:false,
                        numberMode:'input',
                        priceMode:'normal',
                        aduitform:{},
                        aduitloading:false,//审核表单提交状态样式
                        aduitDialog:false,//审核弹窗
                        deptList:[],
                        disabled:false,
                        loading:false,
                        option:formOption,
                        dialogVisible:false,
                        csData:[],
                        csColumns: [
                                { label: "序号", prop: "", type: "index", width: 50 },
                                { label: "物品", prop: "name" },
                                { label: "编号", prop: "code" },
                                { label: "类型", prop: "typeName" },
                                { label: "品牌", prop: "brand" },
                                { label: "规格", prop: "specification" },
                                { label: "生产商", prop: "manufacturer" },
                                { label: "计量单位", prop: "measuringUnitName" },
                                { label: "发放数量", prop: "distributeNum" },
                                {
                                        label: "未用物资数量",
                                        prop: "stockNum",
                                        maxCheck: true,
                                        hide: true,
                                },
                        ],
                        pageLoading: false,
                        prjectList: [],
                        userlist:[],
                        warehouseList: [],
                        warehouseInboundTypeList: [],
                        inboundStatusList: [],
                        dicts: {},

                        editable: "add", 
                        form: {
                                projectId: "",
                                warehouseId: "",
                                type: "",
                                inboundStatus: "",
                                inboundNo: "",
                                linkNo: "",
                                id:'',
                        },
                        addDialogVisible: false,
                        data: [], //入库单列表
                        csData: [],
                        submitFlag:true,
                        mode:'',
                        deptMode:'',
                        
                }
        },
        created() {
                this.fetchData();
        },
        watch:{
                'form.projectId'(val,oldval){
                        if(!this.form.projectId){
                                return;
                        }
                        this.csData = [];
                },
                'form.warehouseId'(val,oldval){
                        if(this.title == '查看'){
                                return;
                        }
                        if(val){
                                // this.viewUpdateConsumableList(this.csData);
                        }
                       
                },
                // 'form.deptId'(val){
                //         console.log(21345544325643425)
                //         if(val){
                //                 console.log(2314251342)
                //                 console.log(val)
                //                 this.getUserNowList(val);
                //         }
                // }

               
        },
         computed: {
            ...mapGetters(['userInfo']),
            
           
        },
        methods:{
                // 科室切换
                deptIdChange(val){
                        this.getUserNowList(val);
                        this.form.acceptUserId = this.userInfo.user_id;
                        
                },
                // 根据当前登录人获取科室
                treeDeptsByIds(){
                        
                        treeDeptsByIds().then(res=>{
                                this.deptList = res.data;
                                if(this.title=='物资发放'){
                                        this.form.deptId = this.deptList[0]?this.deptList[0].id:'';
                                        
                                }
                                this.getUserNowList();
                        })
                },
                // 获取使用人
                getUserNowList(val){
                        getUserNowList({deptId:this.form.deptId||val}).then(res=>{
                                this.useUserList = res.data;
                                this.useUserList.forEach(ele=>{
                                        if(ele.id==this.userInfo.user_id){
                                               this.form.submitUserIdName =   ele.realNameAndPhone;
                                        }
                                })
                                let requisitionUsercolumn  = this.findObject(this.option.column, "acceptUserId");
                                requisitionUsercolumn.dicData = this.useUserList;
                                this.$forceUpdate();
                                

                        })
                },
 
                // 获评变动后回调
                csDataAfterAdd(data,all){
                        // this.viewUpdateConsumableList(all);
                },
                
                // 打开审核弹窗
                openAduitDialog(){
                        this.aduitDialog = true;
                },
              
                // 打开弹窗页面
                openDialog(data){
                        

                        this.form={
                                warehouseId:'',
                                projectId:'',
                                id:'',
                        };
                        this.submitFlag = true;
                        this.csData = [];
                        let projeCtcolumn  = this.findObject(this.option.column, "projectId");
                        projeCtcolumn.dicData = data.dicData.projectIdDictDataList;
                        
                        
                        // userlist
                        // let requisitionUsercolumn  = this.findObject(this.option.column, "acceptUserId");
                        // requisitionUsercolumn.dicData = data.dicData.userlist;
                        data.dicData.userlist.forEach(item=>{
                        item.label = item.realNameAndPhone;
                        item.value = item.userId;
                        })
                        this.userlist = data.dicData.userlist;
                        this.option.submitBtn = true;
                        this.auditBtn = false;
                        this.disabled = false;
                        if(data.type=='add'){
                                this.form.distributeStatus = 1;
                                this.form.submitTime = this.dayjs().format('YYYY-MM-DD HH:mm:ss');
                                this.form.acceptUserId = this.userInfo.user_id;
                                this.form.submitUserId = this.userInfo.user_id;
                               
                                 if(this.title=='物资发放'){
                                        this.form.acceptUserId = this.useUserList[0]?this.useUserList[0].id:'';
                                }
                                
                                this.title = '物资发放';
                                this.numberMode = 'input';
                                this.editable = true;
                                this.priceMode='normal';
                                this.mode = 'no-first';    
                                this.form.projectId=data.dicData.projectIdDictDataList[0].id?data.dicData.projectIdDictDataList[0].id:'';
                                this.form.requisitionUser = this.userInfo.user_id;
                                // let deptId = 
                                // this.form.requisitionDept = this.userInfo.dept_id;

                                this.form.id = '';
                                // this.form.requisitionTime = new Date();
                                // 获取发放单号
                                getBusinessNo({businessType:4}).then(({data})=>{
                                        
                                        this.form.distributeNo = data;
                                })
                                
                                
                                this.option.disabled = false;
                                this.dialogVisible = true;
                        }
                        if(data.type=='view'){
                                this.form.distributeStatus = String(this.form.distributeStatus);
                                this.option.submitBtn = false;
                                this.title = '查看';
                                this.numberMode = 'mormal';
                                this.editable = false;
                                this.printBtn = false;
                                this.mode = 'first';
                                this.disabled = true;
                                this.aduitform.id = data.data.id;
                                this.form = data.data;
                          
                                
                                this.getConsumableListByDistributeId(data.data.id);
                                this.option.disabled = true;

                        }
                        if(data.type=='edit'){
                                this.title = '编辑';
                                this.numberMode = 'input';
                                this.editable = true;
                                this.mode = 'first';
                                this.aduitform.id = data.data.id;
                                this.form = data.data;
                                this.form.submitTime = this.dayjs().format('YYYY-MM-DD HH:mm:ss');
                                
                                
                                
                                this.getConsumableListByDistributeId(data.data.id);
                                this.option.disabled = false;
                                // this.dialogVisible = true;
                                this.form.distributeStatus = Number(this.form.distributeStatus);
                        }
                        
                        this.treeDeptsByIds();
                        
                },
                formError(done){
                        done();
                },
                // 保存 提交    
                submit(type,form,done){
                        if(done){
                                done()
                        }
                        if(type==3){
                                this.dialogVisible = false;
                                this.$emit('onLoad');
                                return;
                        }
                        let validateResult = this.$refs.cs.validate(); 
                        if(!validateResult){
                                console.log(validateResult)
                                return;
                        }
                        let flag = true;
                        this.csData.forEach(ele=>{
                                
                                let a= Number(ele.distributeNum)
                                if(ele.distributeNum == '' || Number(ele.distributeNum)<1){
                                        flag = false;
                                }
                        })
                        if(!flag){
                                this.$message({
                                                message: '请输入正确数量',
                                                type: 'warning'
                                        });
                                return;
                        }
                        if(this.csData.length<1 && type!=3){
                                if(type==1){
                                        this.$message({
                                                message: '请选择物品后再保存',
                                                type: 'warning'
                                        });
                                }else{
                                        this.$message({
                                                message: '请选择物品后再提交',
                                                type: 'warning'
                                        });
                                }
                                
                                return;
                        }
                        this.$refs.form.validate((valid) => {
                                
                                if (valid) {
                                       
                                        this.form.requisitionStatus = type;
                                                                               
                                        this.form.requisitionTime = this.dayjs(this.form.requisitionTime).format('YYYY-MM-DD HH:mm:ss')
                                         if(!this.submitFlag){
                                                 return;
                                                
                                        }
                                        this.submitFlag = false;
                                        this.loading = true;
                                        this.form.consumableListVoList = [];
                                        this.csData.forEach(ele=>{
                                                let temObj = {
                                                        consumableId:ele.consumableId,
                                                        consumableCode:ele.code,
                                                        consumableTypeId:ele.typeId,
                                                        consumableTypeName:ele.typeName,
                                                        consumableMeasuringUnit:ele.measuringUnit,
                                                        distributeNum:ele.distributeNum,
                                                        
                                                };
                                                this.form.consumableListVoList.push(temObj);
                                        })
                                        if(type==1){
                                                distributeSave(this.form).then(res=>{
                                                        this.form.id = res.data.id;
                                                        this.submitFlag = true;
                                                       
                                                        this.$message({
                                                                message: '保存成功',
                                                                type: 'success'
                                                        });
                                                        this.loading = false;
                                                        this.$refs.crud.toggleSelection();
                                                        this.option.disabled = false;
                                                }).catch(res=>{
                                                        this.submitFlag = true;
                                                        this.loading = false;
                                                })
                                        }else if(type==2){
                                                distributeSubmit(this.form).then(res=>{
                                                        this.$message({
                                                                message: '提交成功',
                                                                type: 'success'
                                                        });
                                                        this.loading = false;
                                                        this.dialogVisible = false;
                                                        this.$emit('onLoad');
                                                }).catch(res=>{
                                                        this.$refs.crud.toggleSelection();
                                                        this.submitFlag = true;
                                                        this.loading = false;
                                                })
                                        }

                                } else {
                                        
                                return false;
                                }
                                if(done){
                                        done()   
                                }
                        });
                        

                        
                },
                // 根据id获取材料清单
                getConsumableListByDistributeId(id){
                        let params = {
                                distributeId:id,
                                projectId:this.form.projectId,
                                deptId:this.form.deptId,
                        }
                        getConsumableListByDistributeId(params).then(res=>{
 
                                this.csData = res.data;
                                this.dialogVisible = true;
                        })
                },
                
              
                
                loadData(query, resolve) {
                        query.name = query.text;
                        const params = { ...query, projectId: this.form.projectId,deptId:this.form.deptId };
                        const columns = [
                                { label: "分类", prop: "typeName" },
                                { label: "编号", prop: "code" },
                                { label: "名称", prop: "name" },
                                { label: "计量单位", prop: "measuringUnitName" },
                                { label: "品牌", prop: "brand" },
                                { label: "规格", prop: "specification" },
                        ];
                        consumableList(params).then((res) => {
                                res.data.records.forEach((element) => {
                                element.id = "";
                                });
                                resolve(res.data, columns);
                        });
                },
                loadPrice(query, resolve) {
                        setTimeout(() => {
                                resolve(10.0);
                        }, 500);
                        },
                        async fetchData() {
                        this.pageLoading = true;
                        try {
                                //projectList
                                const resProjectList = await getProjectList();
                                this.prjectList = resProjectList.data;
                                this.form.projectId = this.prjectList[0]
                                ? this.prjectList[0].id
                                : "";
                                
                                //type && status
                                const dicts = await Promise.all([
                                getDict({ code: "warehouse_inbound_type" }),
                                getDict({ code: "inbound_status" }),
                                ]);
                                this.warehouseInboundTypeList = dicts[0].data;
                                this.form.type = this.warehouseInboundTypeList[0].dictKey;
                                this.inboundStatusList = dicts[1].data;
                                this.form.inboundStatus = this.inboundStatusList[0].dictKey;
                                //load list
                                // this.loadList();
                        } catch (err) {
                        }
                        this.pageLoading = false;
                },
        }
}
</script>
